import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.grades.reviewform';

export default defineMessages({
  submittedDate: {
    id: `${scope}.submittedDate`,
    defaultMessage: 'Submitted {createdAt} ',
  },
  ungraded: {
    id: `${scope}.ungraded`,
    defaultMessage: 'Ungraded',
  },
  submitBtn: {
    id: `${scope}.submitBtn`,
    defaultMessage: 'Submit Grade',
  },
  gradeAssigned: {
    id: `${scope}.gradeAssigned`,
    defaultMessage: 'Grade Assigned',
  },
});
